import { api } from "./api";

export const tags = api.injectEndpoints({
  endpoints: builder => ({
    getTags: builder.query({
      query: () => {
        return {
          url: `${process.env.REACT_APP_API_URL}/trips/documents/tags/`,

        }
      },
      keepUnusedDataFor: 5,
    }),
    addTag: builder.mutation({
      query: ({
        name,
        color,
      }) => {
        return {
          url: `${process.env.REACT_APP_API_URL}/trips/documents/tags/`,
          method: 'POST',
          body: {
            name,
            color,
          },
        }
      },
    }),
    deleteTag: builder.mutation({
      query: ({id}) => {
        console.log('id', id)
        return {
          url: `${process.env.REACT_APP_API_URL}/trips/documents/tags/${id}/`,
          method: 'DELETE',
        }
      },
    }),
    updateTag: builder.mutation({
      query: ({
        id,
        name,
        color,
      }) => {
        return {
          url: `${process.env.REACT_APP_API_URL}/trips/documents/tags/${id}/`,
          method: 'PUT',
          body: {
            name,
            color,
          },
        }
      },
    }),
  })
});

export const {
  useGetTagsQuery,
  useAddTagMutation,
  useDeleteTagMutation,
  useUpdateTagMutation,
} = tags;
